<template>
  <div
    class="border-l-2 border-primary circle active relative pl-6 flex flex-wrap w-full items-start pb-12 md:pb-20"
  >
    <div class="w-full md:w-6/12 md:pr-20">
      <p class="text-primary font-secondary uppercase text-sm mb-3">
        {{ tr("DAY") }} {{ day.dayNr }} <span v-if="!noDateView">| {{ day.dateLong }}</span>
      </p>
      <h3
        class="font-secondary text-2xl text-dark"
        v-if="services && services[0]"
      >
        {{ services[0].locationName }}
      </h3>
      <p class="mt-3 destiny-subtitle font-bold relative ml-5" v-if="title">
        {{ title }}
      </p>
      <div class="font-light leading-tight" v-if="services && services[0]">
        <p
          class="mb-3"
          :class="{ 'max-h-0 day-text': hide }"
          v-html="services[0].description"
          :id="'day-text' + day.dayNr"
        ></p>
        <p
          v-if="services[0].passangers && this.nominar != 'NO'"
          class="mb-4 font-regular uppercase relative ml-5 text-sm text-primary"
        >
          <span v-if="services[0].passangers.length > 0">{{ services[0].passangers.length }} {{tr("Guests")}}:</span>
          <span
            v-for="(passanger, i) of services[0].passangers"
            :key="passanger + day.dayNr"
            >{{ passanger
            }}<span v-if="i < services[0].passangers.length - 1">, </span></span
          >
        </p>
      </div>
      <a
        class="text-primary font-light inline-block mb-3 hover:underline cursor-pointer mt-3"
        @click="hide = !hide"
        v-if="showReadMore"
      >
        <span v-if="!hide">{{ tr("Hide") }}</span>
        <span v-else>{{ tr("Read more") }}</span>
      </a>
    </div>
    <div class="w-full md:w-6/12" :id="'images-' + day.dayNr">
      <DaySwiper
        imgClass="img-servcie rounded-xl"
        :images="images"
        v-if="images.length > 0"
      ></DaySwiper>
    </div>
  </div>
</template>

<script>
const s3 = process.env.VUE_APP_S3;
import DaySwiper from "@/components/itinerary/DaySwiper.vue";
const api = window.api;
export default {
  name: "TripDay",
  props: {
    day: Object,
  },
  data() {
    return {
      booking: null,
      readMore: false,
      showReadMore: true,
      images: [],
      hide: true,
      title: null,
    };
  },
  computed: {
    languageNotes() {
      return this.$store.state.languageNotes;
    },
    services() {
      return this.day.services;
    },
    nominar() {
      return this.$store.state?.fitPaxDetail;
    },
    noDateView() {
      return this.$store.state.noDateView;
    },
  },
  async mounted() {
    this.images = [];
    for (let s of this.services) {
      if (!s.code) continue;
      let img = `${s3}/OPT_ID.${s.code}.0.html?v=${Date.now()}`;
      this.images.push({ url: img });
    }
    this.images = Object.assign([], this.images);
    if (this.services && this.services[0] && this.services[0].title) {
      let res = await api.extractText(this.services[0].title);
      if (res) {
        this.title = res;
      }
    }
    setTimeout(() => {
      let divs = document.getElementById("images-" + this.day.dayNr);
      if (divs) {
        let divs2 = document.getElementById("day-text" + this.day.dayNr);
        if (divs2) {
          let vw = Math.max(
            document.documentElement.clientWidth || 0,
            window.innerWidth || 0
          );
          let remp = parseFloat(getComputedStyle(divs2).fontSize);
          let calc = (vw - remp) * 0.226 - 80;

          if (divs2.clientHeight < calc) {
            if (this.day.dayNr == 3) this.showReadMore = false;
            //this.hide = false;
          }
        }
      }
    }, 3000);
  },
  methods: {
    async getImagePath(url) {
      await Promise.resolve(import(`@/assets/${url}`)).then((value) => {
        this.images.push({ url: value.default });
      });
    },
    tr(key) {
      return this.$root.tr(key);
    },
  },
  components: {
    DaySwiper,
  },
};
</script>

<style scoped>
.day-text {
  overflow: hidden;
  max-height: 200px;
  @media screen and (min-width: 798px) {
    max-height: calc(100vw * 0.226 - 80px);
  }
}
</style>
